import { Grid } from "antd";

export const useBreakpoint = () => {
  const screens = Grid.useBreakpoint();

  return screens;
};
